import { useMemo } from 'react'

import { StoreProgramResponse } from '../../services/storeProgramService'

import { StorefrontModeContextState, StorefrontModeContext } from '.'

export default function StorefrontModeContextProvider({
  storeProgramResponse,
  children,
  isB2BMode,
}: {
  storeProgramResponse?: StoreProgramResponse
  children: React.ReactNode
  isB2BMode: boolean
}) {
  const value: StorefrontModeContextState = useMemo(() => {
    return {
      isB2BMode,
      storeProgramResponse,
    }
  }, [storeProgramResponse, isB2BMode])

  return <StorefrontModeContext.Provider value={value}>{children}</StorefrontModeContext.Provider>
}
